import * as React from 'react';
import { translate } from 'react-i18next';

export interface IProps {
  classes: any;
  t: any;
}

class Dashboard extends React.Component<IProps> {
  public render() {
    const { t } = this.props;
    return <p>{t('Home')}</p>;
  }
}

export default translate()(Dashboard);



// WEBPACK FOOTER //
// ./src/routes/Dashboard.tsx